export const DEFAULT_LOGISTICS_CPT_SLABS = {
  '-1': 'Others',
  '1': 'Instant Delivery',
  '2': 'Standard Delivery',
  '-2': 'Self Pickup',
} as const;

export const CPT_SLAB_LABELS_CONFIG_KEY = 'logistics_cpt_slabs';
